import { RouteObject } from "react-router";

import { convertRouteModule } from "../../../lib/routing";

export const peakLoadRoutes: Array<RouteObject> = [
  {
    path: ":accountingPointId?",
    lazy: async () => convertRouteModule(await import("./overview")),
    children: [
      { index: true, lazy: async () => convertRouteModule(await import("./peak-load-details")) },
    ],
  },
];
